import fetchShowroomApi from "../utils/fetch-showroom-api";

customElements.component = 'account-showrooms';

if (!customElements.get(customElements.component)) {
  const selectors = {
    html: "html",
    add: ".js-account-showrooms-add",
    content: ".js-account-showrooms__content",
    card: ".js-account-showroom__card",
    edit: ".js-account-showroom__card-edit",
    delete: ".js-account-showroom__card-delete",
    modal: ".js-modal",
    modalInner: ".js-modal-inner",
    modalEdit: ".js-modal-edit",
    modalDelete: ".js-modal-delete",
    modalClose: ".js-modal-close",
    inputID: ".js-input-id",
    editForm: ".js-edit-form",
    deleteForm: ".js-delete-form",
    datePickerValue: ".js-date-picker-value",
    d: ".js-timer-d",
    h: ".js-timer-h",
    m: ".js-timer-m",
    s: ".js-timer-s"
  }

  class AccountShowrooms extends HTMLElement {
    constructor() {
      super();

      this.html = document.querySelector(selectors.html);
      this.content = this.querySelector(selectors.content);
      this.add = this.querySelector(selectors.add);
      this.modalEdit = this.querySelector(selectors.modalEdit);
      this.modalDelete = this.querySelector(selectors.modalDelete);
      this.editForm = this.querySelector(selectors.editForm);
      this.deleteForm = this.querySelector(selectors.deleteForm);
      this.translations = window.account_showrooms_t;
      this.icons = window.account_showrooms_icons;
      this.showrooms = [];
      this.data = {};

      this.init();
    }

    async getData() {
      this.data = await fetchShowroomApi(`/showrooms`);

      this.data.ownShowrooms && this.data.ownShowrooms.forEach(obj => this.showrooms.push({...obj, isOwner: true}));
      this.data.bridesmaidShowrooms && this.data.bridesmaidShowrooms.forEach(obj => this.showrooms.push(obj));

      if (this.showrooms.length) {
        this.showrooms = this.showrooms.sort((a, b) => {
          const dateA = new Date(a.weddingDate);
          const dateB = new Date(b.weddingDate);

          return dateA - dateB;
        });
      }
    }

    renderShowroomCard(showroom) {
      const isExpired = new Date(showroom.weddingDate) < new Date();

      return `
        <div class="account-showroom__card js-account-showroom__card" data-showroom-id="${showroom.id}">
            <div class="account-showroom__card-row">
                ${this.renderDate(showroom.weddingDate)}
                <div>
                  <div class="account-showroom__card-title">${showroom.title}</div>
                  ${!isExpired ? `
                    <div class="account-showroom__card-timer">
                        <div>
                            <span class="js-timer-d">0</span>
                            <div class="account-showroom__card-timer-label">${this.translations.d}</div>
                        </div>
                        <div>
                            <span class="js-timer-h">0</span>
                            <div class="account-showroom__card-timer-label">${this.translations.h}</div>
                        </div>
                        <div>
                            <span class="js-timer-m">0</span>
                            <div class="account-showroom__card-timer-label">${this.translations.m}</div>
                        </div>
                        <div>
                            <span class="js-timer-s">0</span>
                            <div class="account-showroom__card-timer-label">${this.translations.s}</div>
                        </div>
                    </div>
                    <a href="/pages/showroom-event?id=${showroom.id}" class="account-showroom__card-link">${this.translations.go} ${this.icons.arrow}</a>
                    ` : ``}
                </div>
                ${isExpired ? `<div class="account-showroom__card-label">${this.translations.expired}</div>` : `<div class="account-showroom__card-label">${showroom.currentCustomerIsOwner ? this.translations.bride : this.translations.bridesmaid}</div>`}
                <div class="account-showroom__card-dropdown${showroom.currentCustomerIsOwner ? ' visible' : ''}">
                    <div class="account-showroom__card-dropdown-trigger">${this.icons.dots}</div>
                    <div class="account-showroom__card-dropdown-inner">
                        <div class="account-showroom__card-dropdown-link js-account-showroom__card-edit" data-showroom-id="${showroom.id}">
                            ${this.icons.edit}
                            ${this.translations.edit}
                        </div>
                        <div class="account-showroom__card-dropdown-link js-account-showroom__card-delete" data-showroom-id="${showroom.id}">
                            ${this.icons.delete}
                            ${this.translations.delete}
                        </div>
                    </div>
                </div>
            </div>
        </div>
      `
    }

    renderDate(date) {
      const dateObj = new Date(date);
      const dayOfWeek = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(dateObj);
      const day = new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format(dateObj);
      const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(dateObj);
      const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(dateObj);

      return `
        <div class="account-showroom__card-date">
            <div class="account-showroom__card-dayOfWeek">${dayOfWeek}</div>
            <div class="account-showroom__card-day">${day}</div>
            <div class="m-2.5">${month}, ${year}</div>
        </div>
      `
    }

    initTimers() {
      this.showrooms && this.showrooms.forEach(showroom => {
        const { weddingDate, id } = showroom;

        const card = this.querySelector(`${selectors.card}[data-showroom-id="${id}"]`);
        const date = new Date(weddingDate);
        const d = card.querySelector(selectors.d);
        const h = card.querySelector(selectors.h);
        const m = card.querySelector(selectors.m);
        const s = card.querySelector(selectors.s);

        const timeUnits = [
          { key: d, value: 1000 * 60 * 60 * 24 },
          { key: h, value: 1000 * 60 * 60 },
          { key: m, value: 1000 * 60 },
          { key: s, value: 1000 }
        ];

        const interval = setInterval(() => {
          const now = new Date();
          let difference = date - now;

          if (difference > 0) {
            timeUnits.forEach(unit => {
              unit.key.textContent = Math.floor(difference / unit.value);
              difference %= unit.value;
            });
          } else {
            clearInterval(interval);
          }
        }, 1000);
      });
    }

    initModals() {
      this.editButtons = this.querySelectorAll(selectors.edit);
      this.deleteButtons = this.querySelectorAll(selectors.delete);

      this.editButtons && this.editButtons.forEach(button => button.addEventListener("click", () => this.handleClickEdit(button)))
      this.deleteButtons && this.deleteButtons.forEach(button => button.addEventListener("click", () => this.handleClickDelete(button)))

      this.modalClose = this.querySelectorAll(selectors.modalClose);

      this.modalClose && this.modalClose.forEach(el => el.addEventListener("click", () => this.closeModal(el.closest(selectors.modal))))

      this.modals = this.querySelectorAll(selectors.modal);

      this.modals && this.modals.forEach(modal => modal.addEventListener("click", e => this.handleModalCloseOutside(e, modal)))

      this.editForm && this.editForm.addEventListener("submit", e => this.handleSubmitEditForm(e));
      this.deleteForm && this.deleteForm.addEventListener("submit", e => this.handleSubmitDeleteForm(e));
    }

    handleClickEdit(button) {
      const id = button.getAttribute("data-showroom-id");

      this.modalEdit.querySelector(selectors.inputID).value = id;
      this.modalEdit.querySelector("input[name=name]").value = this.showrooms.find(showroom => showroom.id === id).title;

      this.openModal(this.modalEdit);
    }

    handleClickDelete(button) {
      const id = button.getAttribute("data-showroom-id");

      this.modalDelete.querySelector(selectors.inputID).value = id;

      this.openModal(this.modalDelete);
    }

    async handleSubmitEditForm(e) {
      e.preventDefault();

      const formData = new FormData(this.editForm);
      const id = formData.get("id");

      const body = {
        title: formData.get("name"),
        weddingDate: this.editForm.querySelector(selectors.datePickerValue).value
      }

      await fetchShowroomApi(`/showrooms/${id}`, "PUT", JSON.stringify(body));

      window.location.reload();
    }

    async handleSubmitDeleteForm(e) {
      e.preventDefault();

      const formData = new FormData(this.deleteForm);
      const id = formData.get("id");

      if (window.localStorage.getItem("last_viewed_showroom") === id) {
        window.localStorage.removeItem("last_viewed_showroom");
      }

      if (this.data.ownShowrooms.length) {
        const restShowrooms = this.data.ownShowrooms.filter(showroom => showroom.id !== id);

        restShowrooms.length ? window.localStorage.setItem("last_viewed_showroom", restShowrooms[0].id) : window.localStorage.removeItem("last_viewed_showroom");
      } else if (this.data.bridesmaidShowrooms.length) {
        window.localStorage.setItem("last_viewed_showroom", this.data.bridesmaidShowrooms[0].id);
      }

      await fetchShowroomApi(`/showrooms/${id}`, "DELETE");

      window.location.reload();
    }

    openModal(modal) {
      this.html.classList.add("overflow-hidden");
      modal.classList.add("opened");
    }

    closeModal(modal) {
      this.html.classList.remove("overflow-hidden");
      modal.classList.remove("opened");
    }

    handleModalCloseOutside(e, modal) {
      const modalInner = modal.querySelector(selectors.modalInner);

      if (!modalInner.contains(e.target)) {
        this.closeModal(modal);
      }
    }

    renderNoShowrooms() {
      return `
        <div class="account-showrooms__no">
            <div class="account-showrooms__text">${this.translations.no_showrooms}</div>
            <div class="account-showrooms__buttons">
                <a href="/pages/create-showroom" class="btn text-center">${this.translations.create}</a>
                <span>${this.translations.or}</span>
                <a href="/pages/join-showroom" class="btn text-center">${this.translations.join}</a>
            </div>
        </div>
      `
    }


    render() {
      if (this.showrooms.length) {
        this.showrooms.forEach(showroom => {
          this.content.innerHTML += this.renderShowroomCard(showroom);
        })
      } else {
        this.add.classList.add("hidden");
        this.content.innerHTML = this.renderNoShowrooms();
      }
    }


    async init() {
      await this.getData();
      this.render();
      this.initTimers();
      this.initModals();
    }
  }

  customElements.define(customElements.component, AccountShowrooms);
}
